import { AuctionResource } from 'app/_resources/auction.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { AuthService } from 'app/_services/auth.service';
import { ActivitiesService } from 'app/_services/activities.service';
import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import {
    ComfortBidDtoWithConfig,
    ComfortBidWizardCtx,
    LoggedInUser,
    mgoAngularWizard
} from '../custom';

class ComfortBidWizardConfirmationComponentCtrl implements ng.IController {
    wizardCtrl: mgoAngularWizard.Wizard<ComfortBidWizardCtx>;
    submitting: boolean;

    constructor(
        private auctionResource: AuctionResource,
        private errorHandler: ErrorHandler,
        private authService: AuthService,
        private activitiesService: ActivitiesService,
        private createComfortBidService: { [key: string]: any },
        private utilService: UtilService
    ) {}

    $onInit() {}

    public submit(form: ng.IFormController): boolean {
        if (!form.$valid) {
            return false;
        }

        const comfortBids: ComfortBidDto[] = this.wizardCtrl.context.data
            .map((comfortBidWithConfig: ComfortBidDtoWithConfig) =>
                this.utilService.sanitize<
                    ComfortBidDtoWithConfig,
                    ComfortBidDto
                >(comfortBidWithConfig)
            )
            .map((comfortBid: ComfortBidDto) => {
                comfortBid.networkPoint =
                    this.wizardCtrl.context.selectedNetworkPoint;
                return comfortBid;
            });

        this.submitting = true;

        this.auctionResource
            .createComfortBid(
                comfortBids,
                (res: ComfortBidDto[]) => {
                    const authenticatedUser: LoggedInUser =
                        this.authService.getLoggedInUser();
                    const firstName: string = authenticatedUser.firstName;
                    const lastName: string = authenticatedUser.lastName;

                    this.wizardCtrl.context.successActivities =
                        this.activitiesService.mapToActivities(
                            res,
                            firstName,
                            lastName
                        );
                },
                (err) => {
                    this.errorHandler(err);
                }
            )
            .$promise.finally(() => (this.submitting = false));

        return true;
    }
}

angular.module('app').component('pkpComfortBidWizardConfirmation', {
    controller: ComfortBidWizardConfirmationComponentCtrl,
    template:
        require('app/comfort-bid/comfort-bid-wizard-confirmation.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
